import script from "./MovieCenterMod.vue?vue&type=script&setup=true&lang=js"
export * from "./MovieCenterMod.vue?vue&type=script&setup=true&lang=js"

import "./MovieCenterMod.vue?vue&type=style&index=0&id=76294596&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76294596"]])

export default __exports__